<template>
  <div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="70%" height="14px"></ld-skeleton></div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="40%" height="14px"></ld-skeleton></div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="80%" height="14px"></ld-skeleton></div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="100%" height="14px"></ld-skeleton></div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="50%" height="14px"></ld-skeleton></div>
      <div class="patient-card__skeleton-item"><ld-skeleton width="60%" height="14px"></ld-skeleton></div>
  </div>
</template>

<script>
export default {
  name: "PatientCardWidgetSkeleton",
}
</script>

<style scoped>
  .patient-card__skeleton-item:not(:last-child) {
    margin-bottom: 15px;
  }
</style>
